// This file is generated by the update-rd-teams script. Run "pnpm update:rd-teams" to update.
// It needs to be pushed to the repository. Otherwise, all builds could break if a team changes.
export var teamAliasMappings = {
    abacus: 'abacus',
    'ml-knowai': 'abacus',
    'ml-service-ai': 'abacus',
    'ml-case-assist': 'abacus',
    'ml-smartsnippets': 'abacus',
    'ml-core-nlp': 'abacus',
    'agentic-operation': 'agentic-operation',
    'ai-core': 'ai-core',
    'ai-enablement-committee': 'ai-core',
    'ai-enablement-core': 'ai-core',
    'ai-enablement-champions': 'ai-enablement-champions',
    'backend-foundation': 'backend-foundation',
    'platform-foundation': 'backend-foundation',
    'service-foundation': 'backend-foundation',
    foundation: 'backend-foundation',
    'business-systems': 'business-systems',
    cartel: 'cartel',
    'cloud-infra': 'cloud-infra',
    infrastructure: 'cloud-infra',
    cloudinfra: 'cloud-infra',
    infra: 'cloud-infra',
    'command-fullstack-maintainers': 'command-fullstack-maintainers',
    'commerce-frontend': 'command-fullstack-maintainers',
    'commerce-administrators': 'command-fullstack-maintainers',
    'commerce-implement': 'commerce-implement',
    'commerce-routemasters': 'commerce-routemasters',
    'commerce-analyze': 'commerce-routemasters',
    'commerce-engage-recs-badging-content': 'commerce-routemasters',
    'commerce-rbc': 'commerce-routemasters',
    'commerce-engage-search-listing': 'commerce-routemasters',
    'commerce-sdz': 'commerce-routemasters',
    'commerce-shopify': 'commerce-shopify',
    'connectivity-connectors': 'connectivity-connectors',
    'generic-connectivity': 'connectivity-connectors',
    'native-connectivity': 'connectivity-connectors',
    'service-connectivity': 'connectivity-connectors',
    websites: 'connectivity-connectors',
    wpc: 'connectivity-connectors',
    'connectivity-core': 'connectivity-core',
    'control-conversational': 'control-conversational',
    'control-core': 'control-core',
    'corporate-security': 'corporate-security',
    'corporate-systems': 'corporate-systems',
    'coveo-labs-technical-powerhouse': 'coveo-labs-technical-powerhouse',
    ctinfra: 'ctinfra',
    'connectors-infrastructure': 'ctinfra',
    'data-analytics-engineering': 'data-analytics-engineering',
    'commerce-paparazzi': 'data-analytics-engineering',
    'data-integration': 'data-integration',
    'database-data-management': 'database-data-management',
    dataplatformfoundation: 'dataplatformfoundation',
    usageanalytics: 'dataplatformfoundation',
    'data-foundation': 'dataplatformfoundation',
    'dev-tooling': 'dev-tooling',
    cicd: 'dev-tooling',
    devtooling: 'dev-tooling',
    'devops-ist': 'devops-ist',
    'doc-ops': 'doc-ops',
    'dev-writers': 'doc-ops',
    'api-writers': 'doc-ops',
    'dev-docs': 'doc-ops',
    documentation: 'documentation',
    dxui: 'dxui',
    dx: 'dxui',
    'search-ui': 'dxui',
    searchui: 'dxui',
    finops: 'finops',
    'frontend-foundation': 'frontend-foundation',
    'admin-ui': 'frontend-foundation',
    'admin-ui-core': 'frontend-foundation',
    'ui-tooling': 'frontend-foundation',
    'admin-specialists': 'frontend-foundation',
    grc: 'grc',
    'index-indexing': 'index-indexing',
    index: 'index-indexing',
    'index-core': 'index-indexing',
    'indexing-pipeline': 'index-indexing',
    'index-infrastructure': 'index-infrastructure',
    'index-querying': 'index-querying',
    'index-core-search': 'index-querying',
    'insight-understanding': 'insight-understanding',
    'internal-developer-platform': 'internal-developer-platform',
    'dev-portal': 'internal-developer-platform',
    'it-operations': 'it-operations',
    'knowledge-core': 'knowledge-core',
    'service-core': 'knowledge-core',
    'explore-core': 'knowledge-core',
    'knowledge-data': 'knowledge-data',
    ctsvc: 'knowledge-data',
    'service-data': 'knowledge-data',
    'knowledge-hub': 'knowledge-hub',
    'knowledge-hub-experience': 'knowledge-hub',
    'service-hub': 'knowledge-hub',
    'knowledge-integrations': 'knowledge-integrations',
    'salesforce-integration': 'knowledge-integrations',
    'service-integrations': 'knowledge-integrations',
    'llm-platform': 'llm-platform',
    'llm-ops': 'llm-platform',
    'marketing-website': 'marketing-website',
    'ml-core-ai-dev': 'ml-core-ai-dev',
    'ml-search-relevance': 'ml-core-ai-dev',
    'ml-recommendations': 'ml-core-ai-dev',
    'ml-query-suggest-and-understanding': 'ml-core-ai-dev',
    'ml-experimentation-and-validation': 'ml-experimentation-and-validation',
    'ml-platform-building': 'ml-platform-building',
    'ml-experience': 'ml-platform-building',
    'ml-platform-building-backend': 'ml-platform-building',
    'ml-platform-serving': 'ml-platform-serving',
    'ml-services': 'ml-platform-serving',
    observability: 'observability',
    offsec: 'offsec',
    'platform-identity-and-entitlements': 'platform-identity-and-entitlements',
    organization: 'platform-identity-and-entitlements',
    'platform-resource-insight': 'platform-resource-insight',
    source: 'platform-resource-insight',
    sources: 'platform-resource-insight',
    'platform-solution-experience': 'platform-solution-experience',
    'product-intelligence': 'product-intelligence',
    'product-managers': 'product-managers',
    'real-time-platform': 'real-time-platform',
    'commerce-core': 'real-time-platform',
    rpqi: 'rpqi',
    'recommend-and-personalize-query-and-intent': 'rpqi',
    'recommend-and-personalize': 'rpqi',
    'ml-commerce-ai': 'rpqi',
    'ml-profit': 'rpqi',
    'ml-payg': 'rpqi',
    searchapi: 'searchapi',
    'search-api': 'searchapi',
    'security-cache': 'security-cache',
    'security-engineering': 'security-engineering',
    security: 'security-engineering',
    'rd-defense': 'security-engineering',
    'security-defense-systems-blue': 'security-engineering',
    csec: 'security-engineering',
    soc: 'soc',
    sre: 'sre',
    'cloud-intelligence': 'sre',
    'cloud-ops': 'sre',
    ops: 'sre',
    'team-golden-retrievers': 'team-golden-retrievers',
    'rank-and-retrieve-applied-science': 'team-golden-retrievers',
    'transformation-and-enablement': 'transformation-and-enablement',
    'cloud-advisor': 'transformation-and-enablement',
    cloudadvisors: 'transformation-and-enablement'
};

//# sourceMappingURL=TeamAliasMappings.js.map